module.exports = __webpack_public_path__ + "img/folder.7ba64eda.png";